import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { DownloadsDisabledError, PdfUntrustedOriginError, UserNotInFileOrgError, } from '#pplx/frontend/apps/ask/queries/mutations/errors.js';
import { fileRepositoryClient } from '#pplx_generated/typespec/rest/file_repository/client.js';
export const deleteFilesFromDirectory = async ({ request, reason, }) => {
    const { data, error, response } = await fileRepositoryClient.POST('/rest/file-repository/delete-files', reason, {
        body: request,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to delete files',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
export const downloadFile = async ({ request, reason, signal, }) => {
    const { data, error, response } = await fileRepositoryClient.POST('/rest/file-repository/download', reason, {
        body: request,
        timeoutMs: 2000,
        numRetries: 1,
        signal,
    });
    if (error) {
        if (error.detail && typeof error.detail === 'object' && 'error_details' in error.detail) {
            if (error.detail.error_details === 'DOWNLOADS_DISABLED') {
                throw new DownloadsDisabledError();
            }
            else if (error.detail.error_details === 'PDF_UNTRUSTED_ORIGIN') {
                throw new PdfUntrustedOriginError();
            }
            else if (error.detail.error_details === 'USER_NOT_IN_FILE_ORG') {
                throw new UserNotInFileOrgError();
            }
        }
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to download file',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
export const downloadFileAttachment = async ({ request, reason, }) => {
    const { data, error, response } = await fileRepositoryClient.POST('/rest/file-repository/download-attachment', reason, {
        body: request,
        timeoutMs: 2000,
        numRetries: 1,
    });
    if (error) {
        if (error.detail && typeof error.detail === 'object' && 'error_details' in error.detail) {
            if (error.detail.error_details === 'DOWNLOADS_DISABLED') {
                throw new DownloadsDisabledError();
            }
            else if (error.detail.error_details === 'PDF_UNTRUSTED_ORIGIN') {
                throw new PdfUntrustedOriginError();
            }
            else if (error.detail.error_details === 'USER_NOT_IN_FILE_ORG') {
                throw new UserNotInFileOrgError();
            }
        }
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to download attachment',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=filesMutations.js.map